import React from 'react';
import { GridContainer } from './ChartsWrapper.styles';
import SpendBySubCategory from './ChartsList/SpendBySubCategory';
import VendorsBySpend from './ChartsList/VendorsBySpend';
import SpendByCountry from './ChartsList/SpendByCountry';
import VendorSpendByCategory from './ChartsList/VendorSpendByCategory';
import VendorPareto from './ChartsList/VendorPareto';
import SupplierLandscape from './ChartsList/SupplierLandscape';
import SpendByBusinessUnit from './ChartsList/SpendByBusinessUnit';
import SpendByCostCenter from './ChartsList/SpendByCostCenter';
import DaysPaidOutstanding from './ChartsList/DaysPaidOutstanding';
import SpendOverTime from './ChartsList/SpendOverTime';
import CustomChart from './ChartsList/CustomChart';
import PaymentTermsBySupplier from './ChartsList/PaymentTermsBySupplier';
import ContractConveragePercent from './ChartsList/ContractConveragePercent';
import SupplierClassification from './ChartsList/SupplierClassification';
import SpendByYear from './ChartsList/SpendByYear';

const ChartsWrapper = ({ chartheight, chartsOption, category }) => {
	return (
		<>
			<GridContainer>
				{chartsOption[0].show && <SpendBySubCategory categoryName={category} />}
				{chartsOption[1].show && (
					<VendorsBySpend chartTitle={chartsOption[1].title} />
				)}
				{chartsOption[2].show && (
					<SpendByCountry chartTitle={chartsOption[2].title} />
				)}
				{chartsOption[3].show && (
					<VendorSpendByCategory
						chartheight={chartheight}
						categoryName={category}
					/>
				)}
				{chartsOption[4].show && (
					<VendorPareto chartTitle={chartsOption[4].title} />
				)}
				{chartsOption[5].show && (
					<SupplierLandscape chartTitle={chartsOption[5].title} />
				)}
				{chartsOption[6].show && (
					<SpendByBusinessUnit chartTitle={chartsOption[6].title} />
				)}
				{chartsOption[7].show && (
					<SpendByCostCenter chartTitle={chartsOption[7].title} />
				)}
				{chartsOption[8].show && (
					<DaysPaidOutstanding chartTitle={chartsOption[8].title} />
				)}
				{chartsOption[9].show && (
					<SpendOverTime chartTitle={chartsOption[9].title} />
				)}
				{chartsOption[10].show && (
					<CustomChart chartTitle={chartsOption[10].title} />
				)}
				{chartsOption[11].show && (
					<PaymentTermsBySupplier chartTitle={chartsOption[11].title} />
				)}
				{chartsOption[12].show && (
					<ContractConveragePercent chartTitle={chartsOption[12].title} />
				)}
				{chartsOption[13].show && (
					<SupplierClassification chartTitle={chartsOption[13].title} />
				)}
			</GridContainer>
			<div style={{ padding: '0 0.5% 1%' }}>
				{chartsOption[14].show && (
					<SpendByYear chartTitle={chartsOption[14].title} />
				)}
			</div>
		</>
	);
};

export default ChartsWrapper;
